import api from "services/api";

export const getRolesWithPermissions = async () => {
  return api.get("/v1/api/get-role-list-with-permissions?filterTaken=true");
};

export const getPermissions = async () => {
  return api.get("/v1/api/get-permission-list");
};

export const assignRolePermissions = async (payload) => {
  return api.post("/v1/api/assign-role-permissions", payload);
};
